import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { Store } from '@ngrx/store'
import { AppState } from '../core/store'
import { firstValueFrom, map, tap } from 'rxjs'
import { selectAuthState } from '../core/store/auth/auth.selectors'

export const loadingGuard: CanActivateFn = async (route, state) => {
  const store = inject(Store<AppState>)

  return await firstValueFrom(store.select(selectAuthState).pipe(map((x) => !!!x.username)))
}
